import { X } from "@phosphor-icons/react";
import "./ModalCloseButton.css";

/**
 * Unified close button for all modals/popups.
 * Design: 40×40 rounded button, rotates 90° on hover with red highlight.
 *
 * @param {function} onClick - Close handler
 * @param {string}  [className] - Additional CSS class
 * @param {number}  [size=20] - Phosphor icon size (px)
 */
function ModalCloseButton({ onClick, className = "", size = 20 }) {
  return (
    <button
      className={`modal-close-btn ${className}`.trim()}
      onClick={onClick}
      type="button"
      aria-label="סגור"
    >
      <X size={size} weight="bold" />
    </button>
  );
}

export default ModalCloseButton;
